var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('v-toolbar-items',{staticClass:"ahidden-sm-and-down"},[_c('NotificationVue'),_c('AccountVue')],1):_c('v-toolbar-items',{staticClass:"ahidden-sm-and-down"})}
var staticRenderFns = []

export { render, staticRenderFns }